export default Object.freeze({
  COLOR_CLASSES: {
    PRIMARY_FOCUS: 'primary-focus',
    FOCUS: 'focus',
    GRAY: 'gray',
    GRAY_DARK: 'gray-dark',
    FOCUS_ERROR: 'focus-error',
    SUCCESS: 'success',
    WARNING: 'warning'
  }
})
